import React, { useEffect, useState } from "react";
import "./ImageGrid.css";

// Utility to calculate image aspect ratios
const getImageAspectRatios = (images) => {
    return Promise.all(
        images.map((src) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    const aspectRatio = img.width / img.height;
                    resolve(aspectRatio);
                };
                img.src = src;
            });
        })
    );
};

const ImageGrid = ({ images }) => {
    const [aspectRatios, setAspectRatios] = useState([]);

    useEffect(() => {
        // Calculate the aspect ratio for each image
        getImageAspectRatios(images).then((ratios) => setAspectRatios(ratios));
    }, [images]);

    return (
        <div className="image-grid">
            {images.map((src, index) => (
                <div
                    key={index}
                    className="grid-item"
                    style={{
                        gridRowEnd: `span ${Math.ceil(aspectRatios[index] || 1)}`, // Proportional row span
                    }}
                >
                    <img
                        src={src}
                        alt={`Image ${index}`}
                        className="grid-image"
                        style={{
                            aspectRatio: `${aspectRatios[index] || 1}`, // Maintain aspect ratio
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default ImageGrid;
